export default "__VITE_ASSET__CzKbNghk__"